import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import signModel from './signModel.vue'; //签名组件
import controlAction from './controlAction.vue'; //上移、下移

export default {
  components: {
    signModel,
    controlAction
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      // 传过来index作为唯一index作为标识
      default: () => Number
    },
    formDataArray: {
      type: Array,
      default: () => []
    },
    rulesTrue: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {
    // 获取item
    itemA() {
      return this.item;
    },
    // 获取index
    indexA() {
      return this.index;
    },
    formDataArrayA() {
      return this.formDataArray;
    }
  },
  methods: {
    // 鼠标悬浮事件
    highlight(indexA) {
      this.formDataArrayA[indexA].isHighlighted = true;
    },
    // 鼠标移除的事件监听
    removeHighlight(indexA) {
      this.formDataArrayA[indexA].isHighlighted = false;
    },
    // 点击显示  下拉、上移、编辑按钮
    toggleSelection(indexA, item) {
      this.isActive = indexA;
      this.formDataArrayA[indexA].isSelectedShow = !this.formDataArrayA[indexA].isSelectedShow;
      // 显示 下拉、上移、编辑按钮
      this.formDataArrayA[indexA].isSelected = !this.formDataArrayA[indexA].isSelected;
    },
    // 关联控件
    relationClick(index) {
      this.relationModelVisible = true;
      this.relationModelindexA = index;
      let relationArr = [];
      this.formDataArrayA.forEach((item, index1) => {
        console.log(item);
        console.log(item.partsType);
        if (['singleChoice', 'multipleChoice', 'dropDown'].indexOf(item.partsType) != -1 && index1 < index) {
          relationArr.push(item);
        }
      });
      this.relationData = relationArr;
    },
    // 编辑按钮--打开内容输入内容
    formeClick(index, type) {
      this.activeIndex = index;
      console.log('编辑按钮', this.activeIndex);
      // console.log('编辑点击事件', item, index);
      if (type === 'table') {
        //表格控件的编辑特殊处理
        this.tableId = this.formDataArrayA[index].containerTemplateId;
        if (this.tableId !== -1) {
          let obj = {
            type: 'table',
            tableType: 'increment',
            tableUsage: 'control',
            id: this.tableId,
            mark: this.formDataArrayA[index].mark
          };
          sessionStorage.setItem('tableInitInfo', JSON.stringify(obj));
          this.tableDesignModelVisible = true;
        } else {
          this.tableMark = this.formDataArrayA[index].mark;
          this.containerVisible = true;
        }
      } else {
        this.formDataArrayA[index].editing = !this.formDataArrayA[index].editing;
      }
    },
    // 关闭事件
    formeClase(index) {
      this.formDataArray[index].editing = false;
    }
  }
};